import {Box, Paper, Stack} from '@mui/material'
import {useFormContext} from 'react-hook-form'

import {FormTextInput} from '../../common/inputs/FormTextInput'

import {useStyles} from './CompanyForm.styles'
import {CompanyFormData} from './CompanyForm.types'
import {useCompanyFormData} from './hooks/useCompanyFormData'
import {CompanyCountryInput} from './inputs/CompanyCountryInput'

export interface CompanyFormProps {
  readonlyMode: boolean
  isLoading?: boolean
}

export const CompanyForm = ({readonlyMode, isLoading = false}: CompanyFormProps) => {
  const formMethods = useFormContext<CompanyFormData>()
  const values = formMethods.watch()
  const {classes} = useStyles()
  const testIdPrefix = 'CompanyForm'

  const {countriesIds, selectedCountry} = useCompanyFormData(values)
  return (
    <Paper className={classes.parentPaper}>
      <Box style={{display: 'flex', justifyContent: 'space-between'}}>
        <Stack spacing={2} className={classes.form}>
          <FormTextInput
            readonlyMode={readonlyMode}
            isLoading={isLoading}
            name="name"
            labelTranslationKey="companyForm.companyName"
            autoComplete="name"
            testIdPrefix={testIdPrefix}
          />
          <CompanyCountryInput
            readonlyMode={readonlyMode}
            countriesIds={countriesIds}
            isLoading={isLoading}
            selectedCountry={selectedCountry}
          />
          <FormTextInput
            readonlyMode={readonlyMode}
            isLoading={isLoading}
            name="website"
            labelTranslationKey="companyForm.website"
            autoComplete="website"
            testIdPrefix={testIdPrefix}
          />
          <FormTextInput
            readonlyMode={readonlyMode}
            isLoading={isLoading}
            name="industry"
            labelTranslationKey="companyForm.industry"
            autoComplete="industry"
            testIdPrefix={testIdPrefix}
          />
        </Stack>
      </Box>
    </Paper>
  )
}
